<div class="radio-button-group">
  <label *ngFor="let option of options" class="radio-button-container !cursor-pointer" [class.disabled]="disabled" [class.selected]="option.value === selectedOption.value">
    <input type="radio" name="radio-button-container" [disabled]="disabled" [value]="option.value" (change)="onRadioButtonChange(option)" tabindex="0" />
    <span class="text-base leading-lg font-bold text-n-70 absolute left-2">{{ option.text }}</span>
    <div class="checkmark-container">
      <yat-icon id="5a7b2531-8e46-4302-bc78-acd4d8b65b7b" name="tick-circle-duo"></yat-icon>
    </div>
  </label>
</div>
